module.exports = __webpack_public_path__ + "assets/img/modal-avatar-c2dfa216.png";